import { Theme, makeStyles, createStyles } from '@material-ui/core';
import shell, { StyleProps } from '../theme';

const styles = (theme: Theme) => {
    return createStyles({
        appBar: {
            display: 'flex',
            backgroundColor: (props: StyleProps) => shell[props.mode].header.background,
            height: 80,
            justifyContent: 'center',
            zIndex: theme.zIndex.drawer + 2,
            [theme.breakpoints.down('sm')]: {
                height: 68,
            },
            [theme.breakpoints.down('xs')]: {
                height: 60,
            },
        },
        appBarContainer: {
            alignItems: 'center',
        },

        innerLogoContainer: {
            backgroundColor: 'transparent',
            height: 48,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
                maxWidth: 193,
            },
        },
        logoContainer: {
            display: 'flex',
            justifyContent: 'center',
            '@media(max-width: 320px)': {
                '& svg': {
                    width: 120,
                },
            },
        },
        toolbar: {
            paddingLeft: 16,
            paddingRight: 16,
        },
        companyName: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: 150,
            lineHeight: '1rem',
        },
        menuIcon: {
            color: (props: StyleProps) => shell[props.mode].header.icon,
        },
        menuButton: {
            [theme.breakpoints.up('sm')]: { padding: 8 },
            color: (props: StyleProps) => shell[props.mode].header.text,
        },
        userInfo: {
            color: theme.palette.text.primary,
            lineHeight: '1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 150,
        },
        colorBar: {
            background:
                'linear-gradient(90deg, #FBE53B 0%, #FF4F01 16.82%, #FF14B3 35.13%, #8000FF 55%, #00C1FF 80%, #17F036 99.62%)',
            height: 3,
            width: '100%',
            position: 'absolute',
            top: 0,
        },
    });
};

export default makeStyles(styles, { name: 'MuiShellHeader' });
